import type {
  TrackingEvent,
  TrackingEventName,
  TrackingService,
} from "./TrackingApi";

const { gtag, dataLayer } = window;

export class GoogleAnalytics implements TrackingService {
  eventNames: Map<TrackingEventName, string>;
  currency: string;

  constructor({ currency }: { currency: string }) {
    this.currency = currency;
    this.eventNames = new Map([["addToWishlist", "add_to_wishlist"]]);
  }

  async track({ eventName, product, variant, quantity = 1 }: TrackingEvent) {
    const eventAction = this.eventNames.get(eventName);

    if (!eventAction || !product) {
      return false;
    }

    const itemPrice = (variant?.price ?? product.variants[0].price) / 100;

    if (gtag) {
      gtag("event", eventAction, {
        currency: this.currency,
        value: itemPrice,
        items: [
          {
            item_id: (variant?.sku || variant?.id) ?? product.id,
            item_name: product.title,
            affiliation: "Wishlist King",
            item_category: product.type,
            item_brand: product.vendor,
            item_variant: variant?.title,
            item_quantity: quantity,
            item_price: itemPrice,
          },
        ],
      });

      return true;
    }

    if (dataLayer) {
      dataLayer.push({
        event: eventAction,
        ecommerce: {
          currency: this.currency,
          value: itemPrice,
          items: [
            {
              item_id: (variant?.sku || variant?.id) ?? product.id,
              item_name: product.title,
              affiliation: "Wishlist King",
              item_category: product.type,
              item_brand: product.vendor,
              item_variant: variant?.title,
              item_quantity: quantity,
              item_price: itemPrice,
            },
          ],
        },
      });

      return true;
    }

    return false;
  }
}
